<!-- Conteúdo -->
<div class="main-content" id="main-content">
   <section id="breadcrumbs">
      <div class="container-lg">
         <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
               <div class="br-breadcrumb">
                  <ul class="crumb-list">
                     <li class="crumb home">
                        <a class="br-button circle" [routerLink]="['/']">
                           <span class="sr-only">Página inicial</span>
                           <i class="fas fa-home"></i
                        ></a>
                     </li>
                     <li class="crumb" data-active="active">
                        <i class="icon fas fa-chevron-right"></i>
                        <span>Perguntas Frequentes</span>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
   </section>

   <section id="page">
      <div class="container-lg">
         <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
               <div id="page-title" class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                     <h2>Perguntas Frequentes</h2>
                  </div>
               </div>

               <app-barra-busca
                  [componenteRef]="componenteRef"
                  (inputEvent)="recebeuInput($event)"
                  [mensagem]="mensagem"
               ></app-barra-busca>

               <div id="page-faq" class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                     <span *ngFor="let pergunta of perguntas; let i = index">
                        <app-card
                           [titulo]="pergunta.pergunta"
                           [texto]="pergunta.resposta"
                           [componenteRef]="componenteRef"
                           [tipo]="'faq'"
                           [indice]="i"
                        >
                        </app-card>
                     </span>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </section>

   <section>
      <!-- Paginação -->
      <ng-container *ngIf="totalPaginas">
         <app-paginacao
            [paginaAtual]="paginaAtual"
            [totalPaginas]="totalPaginas"
            (mudouPagina)="onPaginaSelecionada($event)"
         ></app-paginacao>
      </ng-container>
   </section>
</div>
<!-- /Conteúdo -->
